/* eslint-disable react/require-default-props */
import PropTypes from "prop-types";
import Mobile from "./mobile";
import Desktop from "./desktop";

const InputCheckbox = ({
	isMobile,
	title,
	isSelected,
	width,
	margin,
	onClick,
	isAbsolute,
}) => {

	if (isMobile) {

		return (
			<Mobile
				title={title}
				isSelected={isSelected}
				width={width}
				margin={margin}
				onClick={onClick}
				isAbsolute={isAbsolute}
			/>
		);

	}
	return (
		<Desktop
			title={title}
			isSelected={isSelected}
			width={width}
			margin={margin}
			onClick={onClick}
			isAbsolute={isAbsolute}
		/>
	);

};

InputCheckbox.propTypes = {
	isMobile: PropTypes.bool,
	title: PropTypes.string,
	isSelected: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number,
	]).isRequired,
	width: PropTypes.string,
	margin: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	isAbsolute: PropTypes.bool,
};

InputCheckbox.defaultProps = {
	isMobile: false,
	width: "100%",
	margin: "3px",
	isAbsolute: true,
};

export default InputCheckbox;
